export const sectionClass = "px-4 pt-5 py-0 mx-auto sm:px-6 lg:px-6";

export const button = " font-medium text-center rounded-lg focus:outline-none focus:ring-0 focus:ring-offset-0";

export const buttonXS = "px-3 py-2 text-xs";
export const buttonSM = "px-3 py-2 text-sm";
export const buttonBase = "px-5 py-2.5 text-sm";
export const buttonLG = "px-5 py-3 text-base";
export const buttonXL = "px-6 py-3.5 text-base";

// px-4 py-2 text-sm
//text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800
// focus:ring-blue-300
export const blueBgClr = "font-medium text-white bg-blue-700 border border-gray-300 rounded-md shadow-sm  hover:bg-blue-800   focus:ring-transparent";
export const alternativeBgClr = "text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700";
export const darkBgClr = "text-white bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700";
export const lightBgClr = "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700";
export const greenBgClr = "focus:outline-none text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800";
export const redBgClr = "focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900";
export const yellowBgClr = "focus:outline-none text-white bg-yellow-400 hover:bg-yellow-500 focus:ring-4 focus:ring-yellow-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:focus:ring-yellow-900";
export const purpleBgClr = "focus:outline-none text-white bg-purple-700 hover:bg-purple-800 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-5 py-2.5 mb-2 dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-900";

export const paymentsCommands = [
    { id: 11, name: "Payment Invoices", category: "Actions", url: "/payments/invoice" },
    { id: 0, name: "Payment Calendar", category: "Actions", url: "/payments" },
    { id: 13, name: "Working Days", category: "Actions", url: "/payments/working-days" },
    // { id: 12, name: "Bulk Payment", category: "Actions", url: "/payments/bulk" },
    { id: 12, name: "Payment Biling Adjustments", category: "Actions", url: "/payments/adjust" },
    // { id: 1, name: "Resourcewise Account Receivable Statement", category: "Statement", url: "/payments/receivable/user" },
    { id: 2, name: "Monthly Account Receivable Statement", category: "Statement", url: "/payments/receivable/month" },
    { id: 3, name: "Ikat Account Receivable Statement", category: "Statement", url: "/payments/receivable/ikat" },
    { id: 23, name: "RT Account Receivable Statement", category: "Statement", url: "/payments/receivable/rt" },
    { id: 4, name: "Outstanding Payments / Invoices", category: "Statement", url: "/payments/outstanding" },
    { id: 22, name: "LCA Statement", category: "Statement", url: "/timesheet/statement/lca" },
    { id: 21, name: "Monthly Payment Projections", category: "Forecast", url: "" },
];

// "Commercial Partner Company" options for a project mapping.
// Only the rate field matching the selected partner is captured, and only that
// rate is used by the partner's own report. The Payments tab always uses the
// normal project rate regardless of the selected partner.
export const COMMERCIAL_PARTNER_IKAT = "IKAT";
export const COMMERCIAL_PARTNER_RT = "RT";
export const COMMERCIAL_PARTNER_RT_EXCEPTION = "RT exception";

export const commercialPartnerOptions = [
    { value: COMMERCIAL_PARTNER_IKAT, label: "IKAT" },
    { value: COMMERCIAL_PARTNER_RT, label: "RT" },
    { value: COMMERCIAL_PARTNER_RT_EXCEPTION, label: "RT exception" },
];

// Per-project "deduction" applied when billing the IKAT / RT statement.
// The user picks Percentage or Dollars for each project mapping:
//   Percentage  -> effective rate = rate x value%
//   Dollars     -> effective rate = rate - value
// NULL type/value keeps the legacy behaviour: IKAT bills at 75% of the IKAT
// rate and RT bills at 100% of the RT rate.
export const DEDUCTION_TYPE_PERCENTAGE = "percentage";
export const DEDUCTION_TYPE_DOLLARS = "dollars";

export const deductionTypeOptions = [
    { value: DEDUCTION_TYPE_PERCENTAGE, label: "Percentage (%)" },
    { value: DEDUCTION_TYPE_DOLLARS, label: "Dollars ($)" },
];

// Legacy default percentages (effective = rate x pct / 100) used when a
// mapping has no deduction configured. IKAT was fixed at 75%, RT at 100%.
export const IKAT_DEDUCTION_PERCENTAGE_DEFAULT = 75;
export const RT_DEDUCTION_PERCENTAGE_DEFAULT = 100;

export const timesheetCommands = [
    { id: 11, name: "Timesheet Master", category: "Actions", url: "/timesheet/editor/xyz" },
    { id: 12, name: "Timesheet Bulk", category: "Actions", url: "/timesheet/bulkInsert" },
    // { id: 1, name: "Resourcewise Timesheet Statement", category: "Statement", url: "/timesheet/statement/user" },
    { id: 2, name: "Monthly Timesheet Statement", category: "Statement", url: "/timesheet/statement/month" },
    { id: 3, name: "Resourcewise Weekly Timesheet Statement", category: "Statement", url: "/timesheet/statement/week" },
    { id: 4, name: "Resourcewise Fortnightly Timesheet Statement", category: "Statement", url: "/timesheet/statement/fortnight" },
    { id: 5, name: "LCA Statement", category: "Statement", url: "/timesheet/statement/lca" },


    
];

export const employeesCommandActions = [
    { id: 0, name: "Add Employee", category: "Actions", url: "/employees/new" },
    { id: 1, name: "Import Employees", category: "Actions", url: "/employees/import" },
];

export const payrollCommandActions = [
    { id: 0, name: "New Payroll", category: "Actions", url: "/payroll/new" },
    { id: 0, name: "Import Payroll", category: "Actions", url: "/payroll/import" },
    // { id: 1, name: "Active Employees", category: "Modules", url: "/employees" },
    // { id: 2, name: "Monthly Snapshot Report", category: "Report", url: "/payroll/month" },
    { id: 3, name: "Payroll Summary Statement", category: "Statement", url: "/payroll/summary" },
    { id: 4, name: "Payroll Details Statement", category: "Statement", url: "/payroll/detail" },
    { id: 5, name: "YTD Statement", category: "Statement", url: "/payroll/ytd" },
];
